export const headers = (t: any): Header$[] => {
  return [
    {
      value: 'name',
      text: t({ s: 'name', component: 'general' }),
      sortable: false,
      width: 200
    },
    {
      value: 'city',
      text: t({ s: 'table.headers.city', component: 'UserManagement' }),
      sortable: false
    },
    {
      value: 'phone',
      text: t({ s: 'table.headers.phone', component: 'UserManagement' }),
      sortable: false
    },
    {
      value: 'email',
      text: t({ s: 'table.headers.email', component: 'UserManagement' }),
      sortable: false
    },
    {
      value: 'sub_vendor_name',
      text: t({ s: 'table.headers.business', component: 'UserManagement' }),
      sortable: false
    },
    {
      value: 'role',
      text: t({ s: 'table.headers.role', component: 'UserManagement' }),
      sortable: false
    },
    {
      value: 'last_seen_at',
      text: t({ s: 'table.headers.lastSeen', component: 'UserManagement' }),
      sortable: false
    },
    {
      value: 'actions',
      text: t({ s: 'table.headers.actions', component: 'UserManagement' }),
      sortable: false,
      width: 140
    }
  ]
}

export interface User {
  first_name: string;
  id: string;
  last_name: string;
  name?: string;
  sub_vendor_name?: string;
  sub_vendor?: any;
  enterprise_id?: string;
  slug?: string;
  email?: string;
}

interface Header$ {
  value: DefaultUsersHeaderKey | 'actions';
  text: string;
  width?: number;
  sortable?: boolean;
}

type DefaultUsersHeaderKey = 'name' | 'address' | 'postcode' | 'city' | 'phone' | 'email' | 'sub_vendor_name' | 'role' | 'last_seen_at'

export const rules = {
  firstName:
    [(v: string) => !!v || 'First name is required'],
  lastName:
    [(v: string) => !!v || 'Last name is required'],
  role:
    [(v: string) => !!v || 'Role is required'],
  business:
    [(v: string) => !!v || 'Business is required'],
  email:
    [(v: string) => !!v || 'Email is required',
      (v: string) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,255})+$/.test(v) || 'E-mail must be valid']
}

export const defaultUser = {
  firstName: '',
  lastName: '',
  address: '',
  postcode: '',
  city: '',
  phone: '',
  email: '',
  role: null,
  business: null,
  password: ''
}
